import { Component, Input } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * DateTime Cell Renderer
 *
 * Renders date/time values using Angular DatePipe
 * Converts UTC to local time automatically
 * Format: dd/MM/yyyy HH:mm
 *
 * @example
 * ```typescript
 * {
 *   field: 'dateTimeStart',
 *   headerName: 'Fecha Inicio',
 *   cellRenderer: DateTimeCellRendererComponent
 * }
 * ```
 */
@Component({
  selector: 'app-datetime-cell-renderer',
  standalone: true,
  imports: [CommonModule, DatePipe],
  template: `{{ params.value | date: 'dd/MM/yyyy HH:mm' }}`
})
export class DateTimeCellRendererComponent implements CellRenderer<any, Date | string> {
  @Input() params!: CellRendererParams<any, Date | string>;
}
